import { FCSecurePage, PageMetadata } from '@/components/shared/navigation/securePage.ts';

export class PageUtils {
    /**
     * Get the page name from a page component
     * Returns custom pageName if set, otherwise generates from component name
     */
    static getPageName(pageComponent: FCSecurePage): string {
        if (pageComponent.displayName) {
            return pageComponent.displayName;
        }

        const name = pageComponent.displayName || pageComponent.displayName || 'Page';
        return this.componentNameToFriendlyName(name);
    }

    /**
     * Get the page description from a page component
     */
    static getPageDescription(pageComponent: FCSecurePage): string {
        return pageComponent.description || '';
    }

    /**
     * Get the page tags from a page component
     */
    static getPageTag(pageComponent: FCSecurePage): string {
        return pageComponent.tags || '';
    }

    /**
     * Convert component name to friendly display name
     * Example: "DashboardPage" -> "Dashboard"
     */
    private static componentNameToFriendlyName(name: string): string {
        return name
            .replace(/Page$/, '') // Remove 'Page' suffix
            .replace(/Component$/, '') // Remove 'Component' suffix
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
            .trim();
    }

    /**
     * Get all metadata from a page component
     */
    static getMetadata(pageComponent: FCSecurePage): Required<PageMetadata> {
        return {
            displayName: this.getPageName(pageComponent),
            description: this.getPageDescription(pageComponent),
            tag: this.getPageTag(pageComponent)
        };
    }
}
